import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'app-deep-process-output',
  templateUrl: './deep-process-output.component.html',
  styleUrls: ['./deep-process-output.component.css']
})
export class DeepProcessOutputComponent implements OnInit {
  @Input() response: string = "";
  showResponse = false;
  isLoading = false;
  waitingMessage = false;
  safeHtml: SafeHtml;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    // this.sanitize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.response) {
      this.response = this.response.substring(
        this.response.indexOf("```") + 7,
        this.response.lastIndexOf("```")
      );
      this.showResponse = true;
    }
  }
}
